import { ICopiaDiarioObraUseCase } from "../../../presentation/useCases/create/copia_diario_obra_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// CopiaeDiarioObraUseCase


export class CopiaDiarioObraUseCase implements ICopiaDiarioObraUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async copiaDiarioObra( IdDiarioObras: number ): Promise<void> {
    await this.repository.copiaDiarioObra( IdDiarioObras );
  }
}
